import { connect, ConnectedProps } from 'react-redux';
import classNames from 'classnames';

import lang from '../../../lib/language';
import { login as serviceLogin } from '../../../lib/store/common-actions';
import { NullableString } from '../../../lib/util/types';

import { ClickableSpan } from '../../../components';
import LogoAndCloseButton from '../../../components/LogoAndCloseButton/LogoAndCloseButton';
import PoweredBy from '../../../components/PoweredBy/PoweredBy';
import PoweredByMobile from '../../../components/PoweredBy/PoweredByMobile';
import { useIsMobile } from '../../../hooks';
import Button from '../../../shared_components/Button/Button';

import styles from './Layout.module.scss';

type OwnProps = {
  displayNextButton: boolean;
  displayLoginButton: boolean;
  displayBackButton: boolean;
  formSubtitle?: string;
  nextButtonText: NullableString;
  formTitle: string;
  onBackBtnPress?: () => void;
  onSubmit: () => void;
  children: JSX.Element | JSX.Element[];
  transparentContent?: boolean;
  additionalHeight?: number;
};

type Props = OwnProps & ReduxProps;

const BASE_WEB_HEIGHT = 561;
const BASE_MOB_HEIGHT = 482;

const Layout = (props: Props): JSX.Element => {
  const {
    formTitle,
    children,
    onSubmit,
    formSubtitle,
    onBackBtnPress,
    login,
    nextButtonText,
    displayBackButton,
    displayLoginButton,
    displayNextButton,
    transparentContent,
    additionalHeight,
  } = props;
  const { isMobile } = useIsMobile();
  const baseHeight = isMobile ? BASE_MOB_HEIGHT : BASE_WEB_HEIGHT;
  const adjustedHeight = baseHeight + (additionalHeight || 0);
  const heightClass = adjustedHeight ? styles.overrideHeight : '';

  return (
    <div className={styles.container}>
      <div className={classNames(styles.header, { [styles.contentMob]: isMobile })}>
        <LogoAndCloseButton
          displayCloseButton
          displayBackButton={displayBackButton}
          onBackBtnPress={onBackBtnPress}
        />
      </div>
      <div className={styles.wrapperContent}>
        <div
          className={classNames(
            styles.content,
            { [styles.transparentContent]: transparentContent },
            { [styles.contentMob]: isMobile },
            heightClass,
          )}
        >
          <span className={styles.formTitle}>
            {formTitle}
          </span>
          {formSubtitle && <span className={styles.formSubtitle}>{formSubtitle}</span>}
          {children}
          {
            !isMobile && displayNextButton && (
              <div className={styles.row}>
                <Button
                  fullWidth
                  id="createAccount"
                  ariaLabel="create account"
                  onClick={onSubmit}
                  className={styles.button}
                >
                  {nextButtonText ?? lang.commonContinueButton()}
                </Button>
              </div>
            )
          }
          {!isMobile && displayLoginButton && (
            <div className={classNames(styles.row, { [styles.center]: true })}>
              <span className={styles.title}>
                {lang.mobileOnboardingAlreadyHaveAccount()}
                {' '}
                <ClickableSpan onClick={login} className={styles.title}>{lang.mobileOnboardingLogIn()}</ClickableSpan>
              </span>
            </div>
          )}
        </div>
        {isMobile && displayNextButton && (
          <div className={classNames(styles.footer, { [styles.footerMob]: isMobile })}>
            <Button
              fullWidth
              id="createAccount"
              ariaLabel="create account"
              onClick={onSubmit}
              className={styles.button}
            >
              {nextButtonText ?? lang.commonContinueButton()}
            </Button>
          </div>
        )}
        {isMobile && (
          <PoweredByMobile display />
        )}
        { !isMobile && (<PoweredBy display />)}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  login: () => {
    dispatch(serviceLogin('login'));
  },
});

const connector = connect(null, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Layout);
